import { Box, Stack, Typography, useMediaQuery } from "@mui/material";

import { useInsightsContext } from "../context";
import { type Insight } from "../types";
import CloudFlowLabel from "./CloudFlowLabel";
import InsightBadges from "./InsightBadges";
import InsightImpactPreview from "./InsightImpactPreview";
import { InsightTagsList } from "./InsightTagsList";
import UpdatePublishLabel from "./UpdatePublishLabel";

export const Preview = ({ insight, isListView }: { insight: Insight; isListView: boolean }) => {
  const { savingsPeriod } = useInsightsContext();

  const isMobile = useMediaQuery("(max-width:650px)");

  return (
    <Stack className="preview">
      <Box order={isMobile ? 2 : "initial"} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ flexGrow: 1 }}>
          {!isListView && (
            <Typography mb={2} mt="6px" color="text.secondary" variant="body2">
              Insights
            </Typography>
          )}

          <Box display="flex" justifyContent="space-between" gap={2} flexDirection={isMobile ? "column" : "row"}>
            {/* Left content */}
            <Box sx={{ flex: 1 }}>
              <Typography
                data-cy="insight-title"
                variant={isListView ? "h3" : "h1"}
                sx={{
                  ...(isListView && {
                    display: "-webkit-box",
                    overflow: "hidden",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 2,
                    lineHeight: 1.2,
                    ...(isMobile && { display: "inline" }),
                  }),
                }}
              >
                {insight.title}
              </Typography>

              <InsightTagsList insight={insight} />
              <InsightBadges insight={insight} />

              <Stack
                sx={{
                  ...(isListView && {
                    lineHeight: 1.5,
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                  }),
                }}
              >
                <Typography sx={{ mt: 0.5, mb: 0.5 }} color="text.secondary" variant="body2">
                  {insight.shortDescription}
                </Typography>
              </Stack>

              {!isListView && <UpdatePublishLabel insight={insight} />}
              {isListView && <CloudFlowLabel insight={insight} />}
            </Box>

            {isListView && (
              <Box sx={{ minWidth: 150 }}>
                <InsightImpactPreview insight={insight} savingsPeriod={savingsPeriod} />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Stack>
  );
};
